import { Avatar, ConfigProvider, List, Modal, Space, Typography } from 'antd';
const { Text, Link } = Typography;

const data = [
  {
    title: 'Font Sunday X Tony Pritchard award the Oscars of fonts',
    avatar: 'https://scontent-cdg4-1.cdninstagram.com/v/t51.2885-19/21041488_462887190759448_6976386817083834368_a.jpg?stp=dst-jpg_s150x150_tt6&_nc_ht=scontent-cdg4-1.cdninstagram.com&_nc_cat=104&_nc_oc=Q6cZ2AGUr8YapBo3SjVg58EJkMz4Vm8zANrOoUTwg0aU4Cf3Ivqti45S-Z6TNe_wWGXGiAxavTsU1CZoRPg6m_DbwIXl&_nc_ohc=vDXrIvdcttgQ7kNvgGiVuyC&_nc_gid=705ac459c9e84320963d39d4b49e7232&edm=AP4sbd4BAAAA&ccb=7-5&oh=00_AYDZgiI6SH6ZOF8uUc1C6MPuM0uQdv2j6GJNBc1K5I4eMA&oe=67C38B40&_nc_sid=7a9f4b',
    url: 'https://www.typeroom.eu/font-sunday-x-tony-pritchard-award-oscars-of-fonts',
    creator: {
      name: 'Tony Pritchard',
      url: 'https://www.instagram.com/tonypritchard_/'
    },
    source: {
      name: 'typeroom',
      url: 'https://www.typeroom.eu/'
    },
    copyright: {
      name: null,
      url: null
    },
  },
  {
    title: 'PS5 Dualsense - Low Poly',
    avatar: 'https://media.sketchfab.com/avatars/f75008b9a2da4885b073aee9ee088e97/f3cf2738b48d4af78518f70e30585285.png',
    url: 'https://sketchfab.com/3d-models/ps5-dualsense-low-poly-ad6772ad03ba48b3976f910c1eeddf71',
    creator: {
      name: 'A.I.R',
      url: 'https://sketchfab.com/air3ddd'
    },
    source: {
      name: 'Sketchfab',
      url: 'https://sketchfab.com/feed'
    },
    copyright: {
      name: 'Creative Commons Attribution (CC BY)',
      url: 'https://creativecommons.org/licenses/by/4.0/'
    },
  },
  {
    title: 'Thierry Henry',
    avatar: 'https://i.pinimg.com/280x280_RS/f8/85/fc/f885fcdabf126647f70be15ae39c4cca.jpg',
    url: 'https://pinterest.com/pin/801429696205677899/',
    creator: {
      name: 'srwann',
      url: 'https://pinterest.com/comiccoverz/'
    },
    source: {
      name: 'Pinterest',
      url: 'https://pinterest.com'
    },
    copyright: {
      name: null,
      url: null
    },
  },
  {
    title: 'Venom - Marvel Comics',
    avatar: 'https://i.pinimg.com/280x280_RS/21/e8/10/21e810a1b01fa7a3d9d854d12e45ff21.jpg',
    url: 'https://fr.pinterest.com/pin/801429696205677875/',
    creator: {
      name: 'Mestre Arts - Mestre toy',
      url: 'https://fr.pinterest.com/MestreArts/'
    },
    source: {
      name: 'Pinterest',
      url: 'https://pinterest.com'
    },
    copyright: {
      name: null,
      url: null
    },
  },
  {
    title: 'Vought Comics',
    avatar: 'https://i.pinimg.com/280x280_RS/f8/85/fc/f885fcdabf126647f70be15ae39c4cca.jpg',
    url: 'https://fr.pinterest.com/pin/801429696205678090/',
    creator: {
      name: 'srwann',
      url: 'https://pinterest.com/comiccoverz/'
    },
    source: {
      name: 'Pinterest',
      url: 'https://pinterest.com'
    },
    copyright: {
      name: null,
      url: null
    },
  },
];

const Credits = ({setIsModalOpen, isModalOpen}) => {

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const DescriptionLine = ({creatorName, creatorUrl, sourceName, sourceUrl, copyrightName, copyrightUrl}) => {
    return (
      <Space direction={window.innerWidth < 768 ? 'vertical' : 'horizontal'} size='large'>
        <Space size='small'>
          <Text type="secondary">Creator: </Text>
          <Link href={creatorUrl} target="_blank" >{creatorName}</Link>
        </Space>
        <Space size='small'>
          <Text type="secondary">Source: </Text>
          <Link href={sourceUrl} target="_blank" >{sourceName}</Link>
        </Space>
        {copyrightName && 
          <Space size='small'>
            <Text type="secondary">Copyright: </Text>
            <Link href={copyrightUrl} target="_blank" >{copyrightName}</Link>
          </Space>}
      </Space>
    );
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          List: {
            colorBgContainer: '#FFF000',
          },
          Modal: {
            contentBg: '#FAFAFA',
            headerBg: '#FAFAFA',
          }
        },
      }}
    >
      <Modal
        title="Credits"
        centered
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%',
        }}
      >
        <List
          itemLayout={window.innerWidth < 768 ? 'vertical' : 'horizontal'}
          dataSource={data}
          renderItem={item => (
            <List.Item styles={{width:300}}>
              <List.Item.Meta
                avatar={<Avatar src={item.avatar} />}
                title={<a href={item.url} target='_blank' rel="noreferrer" >{item.title}</a>}
                description={<DescriptionLine creatorName={item.creator.name} creatorUrl={item.creator.url} sourceName={item.source.name} sourceUrl={item.source.url} copyrightName={item.copyright.name} copyrightUrl={item.copyright.name} />}
              />
            </List.Item>
          )}
          style={{height:400, overflow:'scroll'}}
        />
      </Modal>
    </ConfigProvider>
  );
};

export default Credits;